import { createFileRoute } from '@tanstack/react-router';
import { NovaVisita } from '@/modules/agronomia/visita/components/NovaVisita';

// Tela 11 · Nova visita técnica (por fazenda; talhão identificado pelo GPS da foto).
export const Route = createFileRoute('/_authed/agronomia_/fazendas_/$id_/visita')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <NovaVisita imovelId={Number(id)} />;
}
